import * as React from 'react'
import type { ClassNameProp } from '@utils';

export const FillParent: React.FC<React.PropsWithChildren<ClassNameProp>> = ({ className, children }) => {
	return <div className={className ?? "h-full w-full"}>{children}</div>;
};
